import React, { useEffect, useMemo } from 'react'

import { cloneDeep } from 'lodash'

import ListsTemplate from 'components_new/templates/internal/Lists'

import { useListsActions } from 'redux/actions/Lists'
import { useListsStore } from 'redux/hooks/Lists'
import PageLayout from 'components_new/templates/PageLayout'

const ListsPage = () => {
  const listsStore = useListsStore()
  const { tryGetListTables } = useListsActions()

  useEffect(() => {
    if (listsStore.tables.length === 0) {
      tryGetListTables()
    }
  }, [])

  const tables = useMemo(() => {
    if (listsStore.tables.length > 0) {
      return cloneDeep(listsStore.tables).sort((t1, t2) => {
        // Sort so that all available tables to export appears first.
        // Then sort alphabetically

        const boolDiff = Number(t2.has_data) - Number(t1.has_data)

        if (boolDiff !== 0) {
          return boolDiff
        }

        return t1.title.toLowerCase() < t2.title.toLowerCase() ? -1 : 1
      })
    }

    return []
  }, [listsStore.tables])

  return (
    <>
      <PageLayout
        content={{ disablePadding: true, fullWidth: true }}
        topbar={{
          breadcrumbs: [{ title: 'Admin' }, { title: 'Listor' }]
        }}
        variant="static"
      >
        <ListsTemplate lists={tables} />
      </PageLayout>
    </>
  )
}

export default ListsPage
